<template>
  <div>
    <el-button
      v-if="activeName != '2'"
      class="button"
      type="primary"
      @click="add(1)"
      >新增</el-button
    >
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="分类管理" name="1">
        <!-- 标题 -->
        <div class="title">
          <div>一级分类管理</div>
          <div>
            <el-button
              type="primary"
              style="margin-top: 20px;"
              @click="editSort()"
              >排序管理</el-button
            >
            <el-button
              v-show="isSortShow"
              type="primary"
              style="margin-top: 20px;"
              @click="saveSortData()"
              >保存排序</el-button
            >
          </div>
        </div>
        <el-table
          :data="classificationDataLv1"
          style="width: 100%; margin-bottom: 20px"
          v-loading="loading"
          v-show="isSortShow"
          ref="multipleTable"
          row-key="id"
          border
        >
          <el-table-column prop="id" align="center" label="ID" width="150">
          </el-table-column>
          <el-table-column prop="name" align="center" label="科室" width="150">
          </el-table-column>
          <el-table-column label="操作" width="200" align="center">
            <template slot-scope="scope">
              <el-button
                type="text"
                icon="el-icon-edit"
                @click="edit(scope.row, 1)"
                >编辑</el-button
              >
              <el-button
                type="text"
                icon="el-icon-delete"
                @click="del(scope.row, 1)"
                >删除</el-button
              >
              <el-button type="text" @click="checkSon(scope.row)"
                >查看子分类</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-table
          :data="classificationDataLv1"
          style="width: 100%; margin-bottom: 20px"
          v-loading="loading"
          v-show="!isSortShow"
          row-key="id"
          border
        >
          <el-table-column prop="id" align="center" label="ID" width="150">
          </el-table-column>
          <el-table-column prop="name" align="center" label="科室" width="150">
          </el-table-column>
          <el-table-column label="操作" width="200" align="center">
            <template slot-scope="scope">
              <el-button
                type="text"
                icon="el-icon-edit"
                @click="edit(scope.row, 1)"
                >编辑</el-button
              >
              <el-button
                type="text"
                icon="el-icon-delete"
                @click="del(scope.row, 1)"
                >删除</el-button
              >
              <el-button type="text" @click="checkSon(scope.row)"
                >查看子分类</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="医案管理" name="2">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <div class="search-left-top">
            <el-form-item label="医案名：">
              <el-input v-model="formInline.title"></el-input>
            </el-form-item>
            <el-form-item label="病名：">
              <el-input v-model="formInline.disease"></el-input>
            </el-form-item>
            <el-form-item label="医家名：">
              <el-input v-model="formInline.doctor"></el-input>
            </el-form-item>
            <!-- <el-form-item label="分类：">
              <el-select v-model="formInline.yianClass">
                <el-option
                  v-for="item in yianClass"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="出处：">
              <el-input v-model="formInline.provenace"></el-input>
            </el-form-item>
          </div>
          <div class="search-left-bottom">
            <el-form-item label="状态：">
              <el-select v-model="formInline.is_shelf">
                <el-option
                  v-for="item in is_shelf"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-form>
        <!-- 标题 -->
        <div class="title">
          <div>医案列表</div>
          <el-button type="primary" @click="search()">查询</el-button>
        </div>
        <el-table :data="yianData" style="width: 100%" v-loading="loading">
          <el-table-column prop="id" label="ID" align="center" width="80">
          </el-table-column>
          <el-table-column
            prop="title"
            label="医案名"
            align="center"
            width="200"
          >
          </el-table-column>
          <el-table-column
            prop="disease"
            label="病名"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="doctor"
            label="医家"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="cate_name"
            label="分类"
            align="center"
            width="150"
          >
          </el-table-column>
          <el-table-column
            prop="provenace"
            label="出处"
            align="center"
            width="200"
          >
          </el-table-column>
          <el-table-column prop="price" label="定价" align="center" width="150">
            <template slot-scope="scope">
              <span v-if="scope.row.is_default_price == 1"
                >{{ scope.row.price }} 元（默认）</span
              >
              <span v-if="scope.row.is_default_price == 0"
                >{{ scope.row.price }} 元（自定义）</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="discount_type"
            label="收费类型"
            align="center"
            width="200"
          >
            <template slot-scope="scope">
              <span>{{ getSflx(scope.row) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="detail(scope.row)">详情</el-button>
              <el-button type="text" @click="edit(scope.row)">编辑</el-button>
              <el-button
                type="text"
                v-if="scope.row.is_shelf == 1"
                @click="isShelf(scope.row, 1)"
                >下架</el-button
              >
              <el-button
                type="text"
                v-if="scope.row.is_shelf == 0"
                @click="isShelf(scope.row, 1)"
                >上架</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination" v-if="yian_totalPages > 1">
          <el-pagination
            background
            layout="prev, pager, next"
            :current-page="yian_currentPage"
            :page-size="yian_page_size"
            :total="yian_pageTotal"
            @current-change="handlePageChange"
          ></el-pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane label="热门列表" name="3">
        <!-- 标题 -->
        <div class="title">
          <div>热门列表</div>
          <div>
            <el-button type="primary" @click="search()">查询</el-button>
          </div>
        </div>
        <el-table
          :data="hotData"
          style="width: 100%"
          v-loading="loading"
          border
        >
          <el-table-column prop="id" label="ID" align="center">
          </el-table-column>
          <el-table-column prop="title" label="标题" align="center">
          </el-table-column>
          <el-table-column prop="summary" label="简介" align="center">
          </el-table-column>
          <el-table-column label="图片" align="center">
            <template slot-scope="scope">
              <el-image
                style="width: 96px; height: 120px"
                :src="scope.row.image_url"
                :preview-src-list="[scope.row.image_url]"
              ></el-image>
            </template>
          </el-table-column>
          <el-table-column label="是否显示" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.is_show == 0">不显示</span>
              <span v-else>显示</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="edit(scope.row)">编辑</el-button>
              <el-button type="text" @click="del(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination" v-if="yian_totalPages > 1">
          <el-pagination
            background
            layout="prev, pager, next"
            :current-page="yian_currentPage"
            :page-size="yian_page_size"
            :total="yian_pageTotal"
            @current-change="handlePageChange"
          ></el-pagination>
        </div>
      </el-tab-pane>
    </el-tabs>

    <!-- 二级分类管理弹出框 -->
    <el-dialog
      :visible.sync="classificationDataLv2Visible"
      width="50%"
      :close-on-click-modal="false"
      v-if="this.activeName == '1'"
    >
      <!-- 标题 -->
      <div class="title">
        <div>二级分类管理</div>
        <el-button class="button" type="primary" @click="add(2)"
          >新增</el-button
        >
      </div>
      <el-table
        :data="classificationDataLv2"
        style="width: 100%; margin-bottom: 20px"
        v-loading="loading"
        border
      >
        <el-table-column prop="id" align="center" label="ID" width="150">
        </el-table-column>
        <el-table-column prop="name" align="center" label="名称" width="150">
        </el-table-column>
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              icon="el-icon-edit"
              @click="edit(scope.row, 3)"
              >编辑</el-button
            >
            <el-button
              type="text"
              icon="el-icon-delete"
              @click="del(scope.row, 3)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination" v-if="hot_currentPage > 1">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="hot_currentPage"
          :page-size="hot_page_size"
          :total="hot_pageTotal"
          @current-change="handlePageChange2"
        ></el-pagination>
      </div>
    </el-dialog>
    <!-- 一级/二级分类编辑弹出框 -->
    <el-dialog
      :visible.sync="editDiseaseVisible"
      width="50%"
      :close-on-click-modal="false"
      v-if="this.activeName == '1'"
    >
      <el-form :model="lv1Form" label-width="120px">
        <el-form-item label="分类名称：" prop="name">
          <el-input v-model="lv1Form.name"></el-input>
        </el-form-item>
        <el-form-item label="名称字母简写：" prop="first">
          <el-input v-model="lv1Form.first"></el-input>
        </el-form-item>
      </el-form>
      <span
        v-if="is_add == false"
        slot="footer"
        class="dialog-footer self-dialog-footer"
      >
        <el-button type="primary" @click="saveEdit()">提 交</el-button>

        <el-button type="primary" @click="editDiseaseVisible = false"
          >取 消</el-button
        >
      </span>
    </el-dialog>
    <!-- 医案管理编辑弹出框 -->
    <el-dialog
      :visible.sync="editYianVisible"
      width="50%"
      :close-on-click-modal="false"
      v-if="this.activeName == '2'"
    >
      <el-form ref="ruleForm" :model="yianForm" label-width="180px">
        <el-form-item label="医案ID：">
          <el-input type="text" v-model="yianForm.id"></el-input>
        </el-form-item>
        <el-form-item label="医案名：">
          <el-input type="text" v-model="yianForm.title"></el-input>
        </el-form-item>
        <el-form-item label="病名：">
          <el-input type="text" v-model="yianForm.disease"></el-input>
        </el-form-item>
        <el-form-item label="医家：">
          <el-input type="text" v-model="yianForm.doctor"></el-input>
        </el-form-item>
        <el-form-item label="出处：">
          <el-input type="text" v-model="yianForm.provenace"></el-input>
        </el-form-item>
        <el-form-item label="类别：">
          <el-input
            type="text"
            disabled="disabled"
            v-model="yianForm.cate_name"
          ></el-input>
        </el-form-item>
        <el-form-item label="标签：">
          <div
            v-for="(item, i) in yianForm.labels"
            :key="i"
            style="margin-bottom: 10px;display: flex;align-items: center;"
          >
            <el-select v-model="item.type" class="handle-select">
              <el-option
                v-for="(child, index) in bqList"
                :key="index"
                :label="child.label"
                :value="child.value"
              ></el-option>
            </el-select>
            <el-input
              type="text"
              v-model="item.title"
              style="width:200px;margin-left: 10px;margin-right: 10px;"
            ></el-input>
            <el-button type="primary" @click="delBq(i)">删 除</el-button>
          </div>
          <el-button type="primary" @click="addBq">添 加</el-button>
        </el-form-item>
        <el-form-item label="定价：">
          <div style="display: flex">
            <el-select
              v-model="f_price"
              class="handle-select"
              @change="selectChange(4, $event)"
            >
              <el-option
                v-for="(child, index) in priceList"
                :key="index"
                :label="child.label"
                :value="child.value"
              ></el-option>
            </el-select>
            <span
              v-if="f_price == 0"
              style="display: flex; justify-content: center; margin-left: 50px"
            >
              <el-input
                v-model="yianForm.price"
                type="text"
                style="margin-right: 10px"
              ></el-input
              >元
            </span>
          </div>
        </el-form-item>
        <div style="display: flex; flex-direction: column; align-items: center">
          <div style="width: 100%; display: flex; align-items: center">
            <el-form-item label="免费状态：" style="margin-bottom: 0">
              <el-select
                v-model="f_discount_type"
                class="handle-select"
                @change="selectChange(5, $event)"
              >
                <el-option
                  v-for="child in free_status"
                  :key="child.value"
                  :label="child.label"
                  :value="child.value"
                ></el-option>
              </el-select>
            </el-form-item>

            <span
              v-if="f_discount_type == 3 || f_discount_type == 4"
              style="display: flex; align-items: center; margin-left: 50px"
            >
              <el-input
                v-model="yianForm.discount.discount"
                type="text"
                style="margin-right: 10px"
              ></el-input
              >%
            </span>
          </div>

          <el-date-picker
            v-if="f_discount_type == 2 || f_discount_type == 4"
            class="handle-date mr10"
            style="margin: 20px 140px 0px 0px"
            v-model="yianForm.date"
            type="datetimerange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd hh:mm:ss"
            @change="dateChange()"
          >
            >
          </el-date-picker>
        </div>
      </el-form>
      <span
        v-if="is_add == false"
        slot="footer"
        class="dialog-footer self-dialog-footer"
      >
        <el-button type="primary" @click="saveEdit()">提 交</el-button>

        <el-button type="primary" @click="editYianVisible = false"
          >取 消</el-button
        >
      </span>
    </el-dialog>
    <!-- 热门列表编辑弹出框 -->
    <el-dialog
      :visible.sync="editHotVisible"
      width="50%"
      :close-on-click-modal="false"
      v-if="this.activeName == '3'"
    >
      <el-form ref="ruleForm" :model="hotForm" label-width="180px">
        <el-form-item label="医案名：">
          <el-input type="text" v-model="hotForm.title"></el-input>
        </el-form-item>
        <el-form-item label="简介：">
          <el-input type="text" v-model="hotForm.summary"></el-input>
        </el-form-item>
        <el-form-item label="是否显示：">
          <el-select v-model="hotForm.is_show" class="handle-select">
            <el-option
              v-for="(child, index) in isShow"
              :key="index"
              :label="child.label"
              :value="child.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="书单图片：" prop="image_url">
          <el-upload
            class="avatar-uploader"
            action
            :show-file-list="false"
            :before-upload="beforeAvatarUpload"
          >
            <img
              v-if="hotForm.image_url"
              :src="hotForm.image_url"
              class="avatar"
              alt="加载失败"
            />
            <em
              v-show="!hotForm.image_url && !uploading"
              class="el-icon-plus avatar-uploader-icon"
            ></em>
            <em
              class="el-icon-loading avatar-uploader-icon"
              v-show="uploading"
            ></em>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer self-dialog-footer">
        <el-button type="primary" @click="saveEdit()">提 交</el-button>

        <el-button type="primary" @click="editHotVisible = false"
          >取 消</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import http from "../../../api/zkApiConfig";
import http2 from "../../../api/uploadApiConfig";
import md5 from "js-md5";
import Sortable from "sortablejs";
export default {
  data() {
    return {
      imageUrl: "",
      editDiseaseVisible: false,
      editYianVisible: false,
      editHotVisible: false,
      classificationDataLv2Visible: false,
      is_add: true,
      lv1_id: "",
      lv2_id: "",
      p_id: "",
      classification_type: 1,
      yian_id: "",
      hot_id: "",
      activeName: "1",
      loading: false,
      father_class: [{ label: "无", value: 0 }],
      // ----------------搜索----------------
      formInline: {},
      yianClass: [],
      is_shelf: [
        {
          value: 1,
          label: "上架",
        },
        {
          value: 0,
          label: "下架",
        },
      ],
      price_type: [],
      isRecommend: [],
      //   一级分类
      classificationDataLv1: [],
      //   二级分类
      classificationDataLv2: [],
      //   医案列表
      yianData: [],
      //   热门列表
      hotData: [],
      //   医案管理分页
      yian_currentPage: 1,
      yian_totalPages: 1,
      yian_page_size: 10,
      yian_pageTotal: 10,
      yian_page_index: 10,
      //   医案热门分页
      hot_currentPage: 1,
      hot_totalPages: 1,
      hot_page_size: 10,
      hot_pageTotal: 10,
      hot_page_index: 10,
      //   二级分类分页
      lv2_currentPage: 1,
      lv2_totalPages: 1,
      lv2_page_size: 10,
      lv2_pageTotal: 10,
      lv2_page_index: 10,
      lv1Form: {},
      yianForm: {},
      // 标签
      labels: "",
      bqList: [
        {
          value: "1",
          label: "书名",
        },
        {
          value: "2",
          label: "书目",
        },
        {
          value: "3",
          label: "作者",
        },
        {
          value: "4",
          label: "科室",
        },
        {
          value: "5",
          label: "医生",
        },
        {
          value: "6",
          label: "出处",
        },
        {
          value: "7",
          label: "疾病",
        },
        {
          value: "9",
          label: "功效",
        },
        {
          value: "10",
          label: "经络",
        },
        {
          value: "11",
          label: "朝代",
        },
        {
          value: "12",
          label: "方剂名",
        },
        {
          value: "13",
          label: "中药名称",
        },
        {
          value: "14",
          label: "经穴名称",
        },
      ],
      hotForm: {},
      //   优先级
      priority: [
        { label: "1", value: 0 },
        { label: "2", value: 1 },
        { label: "3", value: 2 },
        { label: "4", value: 3 },
        { label: "5", value: 4 },
        { label: "6", value: 5 },
        { label: "7", value: 6 },
        { label: "8", value: 7 },
        { label: "9", value: 8 },
        { label: "10", value: 9 },
      ],
      f_price: 0,
      //   热门列表是否显示
      isShow: [
        {
          value: 0,
          label: "不显示",
        },
        {
          value: 1,
          label: "显示",
        },
      ],
      //   定价
      priceList: [
        {
          value: 0,
          label: "自定义",
        },
        {
          value: 1,
          label: "默认公式",
        },
      ],
      //   免费状态
      f_discount_type: 1,
      free_status: [
        {
          value: 0,
          label: "无优惠",
        },
        {
          value: 1,
          label: "免费",
        },
        {
          value: 2,
          label: "限时免费",
        },
        {
          value: 3,
          label: "折扣",
        },
        {
          value: 4,
          label: "限时折扣",
        },
      ],
      //   上传图片
      uploading: false,
      isSortShow: false,
      dataArr: [],
      ids: [],
    };
  },
  mounted() {
    this.getDefault();
  },
  methods: {
    // 排序管理
    editSort() {
      this.isSortShow = !this.isSortShow;
    },
    // 保存排序
    saveSortData() {
      this.ids = [];
      for (let i = 0; i < this.dataArr.length; i++) {
        this.ids.push(this.dataArr[i].id);
      }
      let params = {
        ids: this.ids.toString(),
      };
      http.put("/admin/zk_case/sort/departments", params).then((res) => {
        if (res.data.status_code == 200) {
          this.$message.success("保存成功");
          this.isSortShow = false;
          this.getDefault();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 拖拽
    initSortTable() {
      // 获取 el-table
      const tableTag = this.$refs["multipleTable"].$el;
      // 获取 tbody 节点
      const elTbody = tableTag.querySelectorAll(
        ".el-table__body-wrapper > table > tbody"
      )[0];
      // 拖拽排序
      this.sortable = Sortable.create(elTbody, {
        onEnd: (evt) => {
          const tempIndex = this.dataArr.splice(evt.oldIndex, 1)[0];
          this.dataArr.splice(evt.newIndex, 0, tempIndex);
          console.log(this.dataArr, "dataArr");
        },
      });
    },
    // 时间
    dateChange() {
      this.yianForm.discount.begin_time = this.yianForm.date[0];
      this.yianForm.discount.end_time = this.yianForm.date[1];
    },
    selectChange(type, e) {
      if (type == 4) {
        this.yianForm.price_type == e;
        if (this.yianForm.price_type == 1) {
          this.yianForm.price = 5;
        }
      } else if (type == 5) {
        this.yianForm.discount_type = e;
        this.f_discount_type = e;
      }
      console.log(this.f_discount_type, "f_discount_type");
    },
    addBq() {
      var newItem = { bq_name: "", leiMu: "" };
      this.yianForm.labels.push(newItem);
    },
    delBq(i) {
      this.yianForm.labels.splice(i, 1);
    },
    getDefault() {
      if (this.activeName == 1) {
        this.loading = true;
        http.get("/admin/zk_case/departments").then((res) => {
          if (res.data.status_code == 200) {
            this.classificationDataLv1 = res.data.data;
            this.dataArr = res.data.data;
            this.$nextTick(() => {
              this.initSortTable();
            });
            this.loading = false;
          }
        });
      } else if (this.activeName == 2) {
        this.loading = true;
        let params = {
          page: this.yian_currentPage,
          yian_page_size: this.yian_page_size,
          is_shelf: this.formInline.is_shelf,
          title: this.formInline.title,
          disease: this.formInline.disease,
          doctor: this.formInline.doctor,
          provenace: this.formInline.provenace,
        };
        console.log(params, "params");
        http.get("/admin/zk_case/cases", { params: params }).then((res) => {
          if (res.data.status_code == 200) {
            this.yianData = res.data.data.data;
            this.yian_currentPage = Number(res.data.data.current_page);
            this.yian_totalPages = res.data.data.last_page;
            this.yian_pageTotal = this.yian_totalPages * this.yian_page_size;
            this.loading = false;
          }
        });
      } else if (this.activeName == 3) {
        this.loading = true;
        let params = {
          page: this.hot_currentPage,
          page_size: this.hot_page_size,
        };
        http.get("/admin/zk_case/groups", { params: params }).then((res) => {
          if (res.data.status_code == 200) {
            this.hotData = res.data.data.data;
            this.hot_currentPage = Number(res.data.data.current_page);
            this.hot_totalPages = res.data.data.last_page;
            this.hot_pageTotal = this.hot_totalPages * this.hot_page_size;
            this.loading = false;
          }
        });
      }
    },
    getSflx(row) {
      if (row.discount_type == 0) {
        return "无优惠";
      } else if (row.discount_type == 1) {
        return "免费";
      } else if (row.discount_type == 2) {
        return (
          row.discount.begin_time + "~" + row.discount.end_time + "\n限时免费"
        );
      } else if (row.discount_type == 3) {
        return row.discount.discount + "\n折扣";
      } else if (row.discount_type == 4) {
        return (
          row.discount.begin_time +
          "~" +
          row.discount.end_time +
          "\n" +
          row.discount.discount +
          "%" +
          "\n限时折扣"
        );
      }
    },
    // 搜索
    search() {
      if (this.activeName == 2) {
        this.getDefault();
      } else if (this.activeName == 3) {
        this.getDefault();
      }
    },
    // 新增
    add(type) {
      if (this.activeName == "1") {
        if (type == 1) {
          this.classification_type = 1;
          this.lv1Form = {};
          this.is_add = false;
          this.is_edit = false;
          this.editDiseaseVisible = true;
        } else if (type == 2) {
          this.classification_type = 2;
          this.lv1Form = {};
          this.is_add = false;
          this.is_edit = false;
          this.editDiseaseVisible = true;
        }
      } else if (this.activeName == "2") {
        this.yianForm = {};
        this.editYianVisible = true;
      } else if (this.activeName == "3") {
        this.is_add = true;
        this.hotForm = {};
        this.editHotVisible = true;
      }
    },
    // 提交
    saveEdit() {
      if (this.activeName == "1") {
        if (this.classification_type == 1) {
          if (this.is_edit == true) {
            let params = {
              name: this.lv1Form.name,
            };
            http
              .put("/admin/zk_case/department/" + this.lv1_id, params)
              .then((res) => {
                if (res.data.status_code == 200) {
                  this.$message.success("修改成功");
                  this.getDefault();
                  this.editDiseaseVisible = false;
                } else {
                  this.$message.error(res.data.msg);
                }
              });
          } else {
            let params = {
              name: this.lv1Form.name,
            };
            http.post("/admin/zk_case/department", params).then((res) => {
              if (res.data.status_code == 200) {
                this.$message.success("新增成功");
                this.getDefault();
                this.editDiseaseVisible = false;
              } else {
                this.$message.error(res.data.msg);
              }
            });
          }
        } else if (this.classification_type == 2) {
          if (this.is_edit == true) {
            let params = {
              name: this.lv1Form.name,
              id: this.lv1Form.id,
              first: this.lv1Form.first,
            };
            http
              .put("/admin/zk_case/illness/" + this.lv1Form.p_id, params)
              .then((res) => {
                if (res.data.status_code == 200) {
                  this.$message.success("修改成功");
                  this.checkSon();
                  this.editDiseaseVisible = false;
                } else {
                  this.$message.error(res.data.msg);
                }
              });
          } else {
            let params = {
              name: this.lv1Form.name,
              first: this.lv1Form.first,
            };
            http
              .post("/admin/zk_case/illness/" + this.lv1_id, params)
              .then((res) => {
                if (res.data.status_code == 200) {
                  this.$message.success("新增成功");
                  this.checkSon();
                  this.editDiseaseVisible = false;
                } else {
                  this.$message.error(res.data.msg);
                }
              });
          }
        }
      } else if (this.activeName == "2") {
        // 标签处理
        let labels = this.yianForm.labels;
        let data = "";
        var data1 = "";
        for (let i = 0; i < labels.length; i++) {
          data = labels[i].type + "_" + labels[i].title + ",";
          data1 += data;
        }
        data1 = data1.substring(0, data1.length - 1);
        let params = {
          title: this.yianForm.title,
          disease: this.yianForm.disease,
          doctor: this.yianForm.doctor,
          price: this.yianForm.price,
          provenace: this.yianForm.provenace,
          discount_type: this.f_discount_type,
          labels: data1,
          start_time:
            this.f_discount_type == 2 || this.f_discount_type == 4
              ? this.yianForm.discount.begin_time
              : "",
          end_time:
            this.f_discount_type == 2 || this.f_discount_type == 4
              ? this.yianForm.discount.end_time
              : "",
          discount:
            this.f_discount_type == 3 || this.f_discount_type == 4
              ? this.yianForm.discount.discount
              : "",
        };
        console.log(params, "params");
        http.put("/admin/zk_case/case/" + this.yian_id, params).then((res) => {
          if (res.data.status_code == 200) {
            this.$message.success("修改成功");
            this.getDefault();
            this.editYianVisible = false;
          } else {
            this.$message.error(res.data.msg);
          }
        });
      } else if (this.activeName == "3") {
        if (this.is_add == true) {
          let params = {
            title: this.hotForm.title,
            summary: this.hotForm.summary,
            image: this.hotForm.image,
            is_show: this.hotForm.is_show,
          };
          http.post("/admin/zk_case/group", params).then((res) => {
            if (res.data.status_code == 200) {
              this.$message.success("修改成功");
              this.getDefault();
              this.editHotVisible = false;
            } else {
              this.$message.error(res.data.msg);
            }
          });
        } else {
          let params = {
            title: this.hotForm.title,
            summary: this.hotForm.summary,
            image: this.hotForm.image,
            is_show: this.hotForm.is_show,
          };
          http
            .put("/admin/zk_case/group/" + this.hot_id, params)
            .then((res) => {
              if (res.data.status_code == 200) {
                this.$message.success("修改成功");
                this.getDefault();
                this.editHotVisible = false;
              } else {
                this.$message.error(res.data.msg);
              }
            });
        }
      }
    },
    // 查看子分类
    checkSon(row) {
      if (row && row.id) {
        console.log(row);
        this.lv1_id = row.id;
      }
      this.classificationDataLv2Visible = true;
      let params = {
        page: this.lv2_currentPage,
        page_size: this.lv2_page_size,
      };
      http
        .get("/admin/zk_case/illness/" + this.lv1_id, { params: params })
        .then((res) => {
          if (res.data.status_code == 200) {
            console.log(res, "res");
            this.classificationDataLv2 = res.data.data.data;
            this.lv2_currentPage = Number(res.data.data.current_page);
            this.lv2_totalPages = res.data.data.last_page;
            this.lv2_pageTotal = this.lv2_totalPages * this.lv2_page_size;
          }
        });
    },
    getDetail() {
      if (this.activeName == "1") {
        console.log("detail1");
        // this.editDiseaseVisible = true;
      } else if (this.activeName == "2") {
        http.get("/admin/zk_case/case/" + this.yian_id).then((res) => {
          if (res.data.status_code == 200) {
            this.yianForm = res.data.data;
            this.f_discount_type = this.yianForm.discount_type;
            let data = res.data.data;
            // 免费状态
            if (data.discount_type == 0) {
              this.yianForm.discount_type = "无优惠";
            } else if (data.discount_type == 1) {
              this.yianForm.discount_type = "免费";
            } else if (data.discount_type == 2) {
              this.yianForm.discount_type = "限时免费";
              this.$set(this.yianForm, "date", [
                data.discount.begin_time,
                data.discount.end_time,
              ]);
            } else if (data.discount_type == 4) {
              this.yianForm.discount_type = "限时折扣";
              this.$set(this.yianForm, "date", [
                data.discount.begin_time,
                data.discount.end_time,
              ]);
            }
            // 定价
            if (data.is_default_price == 0) {
              this.f_price = 0;
            } else if (data.is_default_price == 1) {
              this.f_price = 1;
            }
          }
        });
      } else if (this.activeName == "3") {
        http.get("/admin/zk_case/group/" + this.hot_id).then((res) => {
          if (res.data.status_code == 200) {
            this.hotForm = res.data.data;
          }
        });
      }
    },
    // 详情
    detail(row) {
      if (this.activeName == "2") {
        this.is_add = true;
        this.editYianVisible = true;
        this.yian_id = row.id;
        this.getDetail();
      }
    },
    // 编辑
    edit(row, type) {
      if (this.activeName == "1") {
        if (type == 1) {
          this.classification_type = 1;
          this.is_add = false;
          this.is_edit = true;
          this.editDiseaseVisible = true;
          this.lv1_id = row.id;
        } else if (type == 2) {
          this.classification_type = 2;
          console.log(row, "111");
          this.is_add = false;
          this.is_edit = true;
          this.editDiseaseVisible = true;
          this.lv1Form = {
            name: row.name,
            id: row.id,
            p_id: row.p_id,
            first: row.first,
          };
        }
      } else if (this.activeName == "2") {
        this.editYianVisible = true;
        this.is_add = false;
        this.yian_id = row.id;
        this.getDetail();
      } else if (this.activeName == "3") {
        this.editHotVisible = true;
        this.is_add = false;
        this.hot_id = row.id;
        this.getDetail();
      }
    },
    // 删除
    del(row, type) {
      if (this.activeName == "1") {
        let that = this;
        if (type == 1) {
          that
            .$confirm("确定要删除吗？", "提示", {
              type: "warning",
            })
            .then(() => {
              http.delete("/admin/zk_case/department/" + row.id).then((res) => {
                if (res.data.status_code == 200) {
                  that.getDefault();
                  that.$message.success("已删除");
                } else {
                  that.$message.error(res.data.msg);
                }
              });
            })
            .catch(() => {});
        } else if (type == 2) {
          that
            .$confirm("确定要删除吗？", "提示", {
              type: "warning",
            })
            .then(() => {
              http.delete("/admin/zk_case/illness/" + row.id).then((res) => {
                if (res.data.status_code == 200) {
                  that.checkSon();
                  that.$message.success("已删除");
                } else {
                  that.$message.error(res.data.msg);
                }
              });
            })
            .catch(() => {});
        }
      } else if (this.activeName == "3") {
        let that = this;
        that
          .$confirm("确定要删除吗？", "提示", {
            type: "warning",
          })
          .then(() => {
            http.delete("/admin/zk_case/group/" + row.id).then((res) => {
              if (res.data.status_code == 200) {
                that.getDefault();
                that.$message.success("已删除");
              } else {
                that.$message.error(res.data.msg);
              }
            });
          })
          .catch(() => {});
      }
    },
    // 选项卡
    handleClick(tab) {
      if (tab.index == 1) {
        this.loading = true;
        let params = {
          page: this.yian_currentPage,
          yian_page_size: this.yian_page_size,
          is_shelf: this.formInline.is_shelf,
          title: this.formInline.title,
          disease: this.formInline.disease,
          doctor: this.formInline.doctor,
          provenace: this.formInline.provenace,
        };
        http.get("/admin/zk_case/cases", { params: params }).then((res) => {
          if (res.data.status_code == 200) {
            this.yianData = res.data.data.data;
            this.yian_currentPage = Number(res.data.data.current_page);
            this.yian_totalPages = res.data.data.last_page;
            this.yian_pageTotal = this.yian_totalPages * this.yian_page_size;
            this.loading = false;
          }
        });
      } else if (tab.index == 2) {
        this.loading = true;
        let params = {
          page: this.hot_currentPage,
          page_size: this.hot_page_size,
        };
        http.get("/admin/zk_case/groups", { params: params }).then((res) => {
          if (res.data.status_code == 200) {
            this.hotData = res.data.data.data;
            this.hot_currentPage = Number(res.data.data.current_page);
            this.hot_totalPages = res.data.data.last_page;
            this.hot_pageTotal = this.hot_totalPages * this.hot_page_size;
            this.loading = false;
          }
        });
      }
    },
    // 医案分类二级分页
    handlePageChange2(val) {
      this.hot_currentPage = val;
      this.getDefault();
    },
    // 医案分类二级分页
    handlePageChange1(val) {
      this.lv2_currentPage = val;
      this.checkSon(this.lv2_id);
    },
    // 医案管理分页
    handlePageChange(val) {
      this.yian_currentPage = val;
      this.getDefault();
    },
    // 时间
    formatDate(time) {
      return new Date(time * 1000).Format("YYYY-MM-DD hh:mm:ss");
    },
    // 上下架
    isShelf(row, type) {
      if (type == 1) {
        let that = this;
        if (row.is_shelf == 1) {
          that
            .$confirm("确定要下架吗？", "提示", {
              type: "warning",
            })
            .then(() => {
              http.post("/admin/zk_case/shelf/" + row.id).then((res) => {
                if (res.data.status_code == 200) {
                  that.getDefault();
                  that.$message.success("已下架");
                } else {
                  that.$message.error(res.data.msg);
                }
              });
            })
            .catch(() => {});
        } else {
          //
          that
            .$confirm("确定要上架吗？", "提示", {
              type: "warning",
            })
            .then(() => {
              http.post("/admin/zk_case/shelf/" + row.id).then((res) => {
                if (res.data.status_code == 200) {
                  that.getDefault();
                  that.$message.success("已上架");
                } else {
                  that.$message.error(res.data.msg);
                }
              });
            })
            .catch(() => {});
        }
      }
    },

    // 图片上传
    beforeAvatarUpload(file) {
      console.log(file, "file");
      let that = this;
      const isJPG = file.type === "image/jpeg" || "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (isJPG && isLt2M) {
        var ossData = new FormData();
        let imgType = file.type.split("/")[1];
        let fileNames = file.name.split("/")[0];
        var time = new Date().getTime();
        var filename = md5(time + fileNames) + "." + imgType;
        ossData.append("work_path", "icon/zsk");
        ossData.append("bucket", "family-tcm");
        ossData.append("end_point", "oss-cn-hangzhou.aliyuncs.com");
        ossData.append("rewrite", "1");
        ossData.append("file_name", filename);
        ossData.append("file", file);
        that.uploading = true;
        http2.post("upload", ossData).then(function(res) {
          if (res.data.status_code == 200) {
            that.hotForm.image = "icon/zsk/" + filename;
            that.hotForm.image_url = URL.createObjectURL(file);
          }
          that.uploading = false;
        });
      } else if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      } else if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
  },
};
</script>

<style scoped>
.header-tab {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.button {
  height: 40px;
  position: absolute;
  right: 28px;
  z-index: 999;
}
.title {
  width: 100%;
  padding: 10px 0;
  font-size: 22px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.table-td-thumb {
  display: block;
  margin: auto;
  width: 180px;
  height: 180px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
/deep/#tab-1-1 {
  width: 200px !important;
}
/deep/.el-tabs__item {
  width: 300px !important;
  text-align: center;
}
/deep/.is-active {
  border-bottom-color: #409eff !important;
}
/deep/.el-table__header {
  width: 100% !important;
}
/deep/.el-table__empty-block {
  width: 100% !important;
}
/deep/.el-table__body {
  width: 100% !important;
}
</style>
